export var ssrSuccess = function ssrSuccess(ssr) {
  if (ssr !== null && ssr !== void 0 && ssr.getDoneMark()) {
    return {
      'ssr:success': true
    };
  }

  return null;
};